import _Defaults from "../v3_3/Defaults";
import _Defaults2 from "./Defaults";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToPrevious = exports.convertFromPrevious = void 0;
const Defaults_1 = _Defaults;
const Defaults_2 = _Defaults2;
const convertFromPrevious = (s, v) => {
  const settings = Defaults_2.Defaults();
  const oldSettings = s;
  settings.ar = oldSettings.ar;
  settings.build_date = oldSettings.build_date;
  settings.build_version = oldSettings.build_version;
  settings.camera = oldSettings.camera;
  settings.light = oldSettings.light;
  settings.session = oldSettings.session;
  settings.environmentGeometry = oldSettings.environmentGeometry;
  settings.rendering = oldSettings.rendering;
  settings.general.transformation = oldSettings.general.transformation;
  settings.general.blurWhenBusy = oldSettings.general.blurWhenBusy;
  settings.general.commitSettings = oldSettings.general.commitSettings;
  settings.general.commitParameters = oldSettings.general.commitParameters;
  settings.general.pointSize = oldSettings.general.pointSize;
  settings.general.showMessages = oldSettings.general.showMessages;
  settings.general.defaultMaterialColor = "#199b9bff";
  settings.environment.clearAlpha = oldSettings.environment.clearAlpha;
  settings.environment.clearColor = oldSettings.environment.clearColor;
  settings.environment.map = oldSettings.environment.map;
  settings.environment.mapAsBackground = oldSettings.environment.mapAsBackground;
  settings.environment.mapResolution = oldSettings.environment.mapResolution;
  settings.environment.rotation = {
    x: 0,
    y: 0,
    z: 0,
    w: 1
  };
  settings.environment.blurriness = 0;
  settings.environment.intensity = 1;
  return settings;
};
exports.convertFromPrevious = convertFromPrevious;
const convertToPrevious = (s, v) => {
  const settings = Defaults_1.Defaults();
  const newSettings = s;
  settings.ar = newSettings.ar;
  settings.build_date = newSettings.build_date;
  settings.build_version = newSettings.build_version;
  settings.camera = newSettings.camera;
  settings.light = newSettings.light;
  settings.session = newSettings.session;
  settings.environmentGeometry = newSettings.environmentGeometry;
  settings.rendering = newSettings.rendering;
  settings.general.transformation = newSettings.general.transformation;
  settings.general.blurWhenBusy = newSettings.general.blurWhenBusy;
  settings.general.commitSettings = newSettings.general.commitSettings;
  settings.general.commitParameters = newSettings.general.commitParameters;
  settings.general.pointSize = newSettings.general.pointSize;
  settings.general.showMessages = newSettings.general.showMessages;
  settings.environment.clearAlpha = newSettings.environment.clearAlpha;
  settings.environment.clearColor = newSettings.environment.clearColor;
  settings.environment.map = newSettings.environment.map;
  settings.environment.mapAsBackground = newSettings.environment.mapAsBackground;
  settings.environment.mapResolution = newSettings.environment.mapResolution;
  return settings;
};
exports.convertToPrevious = convertToPrevious;
//# sourceMappingURL=Converter.js.map
export default exports;